import Header from './components/Header';
import HeroSection from './components/HeroSection';
import ContactSection from './components/ContactSection';
import IndexSection from './components/IndexSection';
import CardsSection from './components/CardsSection';
import UpdatesSection from './components/UpdatesSection';
import CarouselSection from './components/CarouselSection';
import CommentsSection from './components/CommentsSection';
import MediaSection from './components/MediaSection';
import RankingSection from './components/RankingSection';
import FAQSection from './components/FAQSection';
import AboutSection from './components/AboutSection';
import FeaturesSection from './components/FeaturesSection';
import TopicsSection from './components/TopicsSection';
import AppSection from './components/AppSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="relative min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <ContactSection />
        <IndexSection />
        <CardsSection />
        <UpdatesSection />
        <CarouselSection />
        <CommentsSection />
        <MediaSection />
        <RankingSection />
        <FAQSection />
        <AboutSection />
        <FeaturesSection />
        <TopicsSection />
        <AppSection />
      </main>
      <Footer />
    </div>
  );
}